import { fmtBaht } from './Chrome';

///////////////////////////////////////////////////////////////////////////////
// Shared helpers for Top Me Up (creator page in Account.jsx, payer page in
// TopupPay.jsx). Requests are denominated in THB (Thai receiver numbers) or
// USD (any other country's number — payer is still charged in THB).
///////////////////////////////////////////////////////////////////////////////

// Used only until GET /api/topup-requests/config answers (or if it fails).
export const TMU_FALLBACK_LIMITS = {
  THB: { min: 20, max: 5000, presets: [100, 300, 500, 1000] },
  USD: { min: 5, max: 100, presets: [5, 10, 20, 50] },
};

// THB: whole baht (same as the rest of the app). USD: "$5" for whole amounts,
// "$5.50" otherwise; pass exact=true to always show cents (fee/total rows).
export function fmtTmu(n, currency, exact) {
  if (currency !== 'USD') return fmtBaht(n);
  const v = Number(n || 0);
  return `$${exact || !Number.isInteger(v) ? v.toFixed(2) : v}`;
}

// Baht with satang — for the THB amount a payer is actually charged
export function fmtThbExact(n) {
  return `฿${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Mirrors the server rule: a number without '+' is a Thai local number, a
// '+66'/'0066' number is Thai, any other '+'/'00' number is international.
export function tmuPhoneKind(raw) {
  const s = String(raw || '').replace(/[\s().-]/g, '');
  if (!s) return 'empty';
  if (/^(\+|00)66/.test(s) || /^0(?!0)/.test(s)) return 'thai';
  if (/^(\+|00)\d/.test(s)) return 'global';
  return 'unknown';
}
